export interface Status {
  ongoing: number;
  critical: number;
  inactive: number;
  completed: number;
}

export interface Movimiento {
  id: number;
  proc: string;
  createdAt: Date;
  fecha: Date | string;
  tipo_de_mto: string;
  usuario: string;
  descripcion: string;
  Proc: {
    ACTO: string;
    DEMA: string;
    TPRO: string;
    Ojud: { nombre_corto: string };
  };
  Miembro: string;
  clase_de_mto: string;
  clase_fk: number;
}

export const mtoInicial: Movimiento = {
  id: 1437,
  proc: '5yURv&mC0q',
  createdAt: new Date(),
  fecha: new Date(),
  tipo_de_mto:'', 
  usuario: '',
  descripcion: '',
  Proc: {
    ACTO: 'ZERRIZUELA SERGIO DANIEL',
    DEMA: 'GALENO ASEGURADORA DE RIESGOS DEL TRABAJO S.A.',
    TPRO: 'ENFERMEDAD',
    Ojud: {
      nombre_corto: 'TT1 LZ'
    }
  },
  Miembro: '',
  clase_de_mto: '',
  clase_fk: 0,
};
